/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/styles";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkValidation from "../../lib/utils/checkValidation";
import checkConditionWithMsg from "../../lib/utils/checkConditionWithMsg";

import Dialog from "../dialog/functional/Dialog";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";
import AutoForm from "../form/functional/AutoForm";
import DialogHeaderWithClose from "../dialog/functional/DialogHeaderWithClose";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import BadItemList from "../screens/BadItemList";
import layoutConf from "../../config/layoutConf";
import Button from "../input/Button";
import { CollectionView } from "@grapecity/wijmo";

import { cloneDeep } from "lodash";
import BasicStaticGridScreenType from "../screenTypes/functional/BasicStaticGridScreenType";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px"
    },

    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },
}));

function InspectionItemMoveDialog (props) {
    const {
        id, schema, process, moveable, resizable, fullWidth, maxWidth, onClose,
        onInitialized, initialData, onSuccess, ...others
    } = props;

    const  classes = useStyles ();
    const {t} = useTranslation ();

    const [instance, setInstance] = useState ();
    const [interaction, setInteraction] = useState(false);
    const [formData, setFormData] = useState({});
    const [keepOpen, setKeepOpen] = useState(false);
    const [failedLotList, setFailedLotList] = useState ([]);
    const [modifiedSchema, setModifiedSchema] = useState();
    const [, setCollectionView] = useState();
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });
    
    useEffect(() => {
        if(schema) {
            let modifiedSchema = cloneDeep(schema);
            for( const column of modifiedSchema.columns) {
                switch(column.name) {
                    case "lotNo":
                        column.hideInForm = false;
                        column.disabled = true;
                        break;

                    case "materialCode":
                        column.disabled = true;
                        break;

                    case "materialCodeVer":
                        column.disabled = true;
                        break;

                    case "materialName":
                        column.disabled = true;
                        break;
                    
                    case "materialTypeName":
                        column.hideInForm = true;
                        break;

                    case "wareHouseCode":
                        column.hideInForm = false;
                        column.disabled = true;
                        break;

                    case "wareHouseName":
                        column.hideInForm = false;
                        column.disabled = true;
                        break;

                    case "wareHouseType":
                        column.hideInForm = true;
                        break;
                    
                    case "workState":
                        column.hideInForm = true;
                        break;

                    case "failureCode":
                        column.hideInForm = true;
                        column.formGroup = 1;
                        break;

                    case "qty":
                        column.hideInForm = true;
                        column.formGroup = 1;
                        break;

                    case "qtyQueued":
                        column.hideInForm = false;
                        column.disabled = true;
                        break;

                    case "afterWarehouseCode":
                        column.hideInForm = true;
                        break;

                    case "moveWarehouseCode":
                        column.hideInForm = false;
                        column.formGroup = 1;
                        break;

                    case "processCode":
                        column.hideInForm = true;
                        break;

                    case "processId":
                        column.hideInForm = true;
                        break;

                    case "machineCode":
                        column.hideInForm = true;
                        break;

                    case "lineNo":
                        column.hideInForm = true;
                        break;

                    case "extLotNo":
                        column.hideInForm = true;
                        break;
                        
                    case "inspectionDate":
                        column.hideInForm = true;
                        break;
    
                    default :
                        break;
                }
            }

            setModifiedSchema(modifiedSchema);
        }
    }, [schema]);

    const checkItemValidation = (schema, formData) => {
        for (const column of schema.columns) {
            let [valid, msg] = checkValidation ("create", column, column.validation, formData[column.name] || "");
            if (!valid) {
                nofifyWarning (msg);
                return false;
            }
        }
        return true;
    }

    const nofifyWarning = (msg) => {
        console.warn(msg);
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onDialogInitialized = (instance) => {
        setInstance(instance);
        if (onInitialized) {
            onInitialized(instance);
        }
    };

    const onApiSuccess = (result) => {
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
            }
            return newFormData;
        });

        setKeepOpen ((keepOpen) => {
            if (!keepOpen) {
                instance.hide();
            }
            return keepOpen;
        });

        if (onSuccess) {
            onSuccess(result.data);
        }
    };

    const onApiFailure = (reason) => {
        notifyFailure (t(reason.response.data));
    };

    const onOk = () => {
        // 화면에 보이는 칸(이동 창고 등)의 필수 검사는 창에서 바꾼 스키마로 한다 — 원 스키마에서는 이동 창고가 숨은 칸이라 비워도 서버로 갔다
        save(modifiedSchema || schema, formData);
    }

    function save(schema, formData) {
        if (!checkItemValidation(schema, formData)) {
            console.error("Form Validation Failed");
            return;
        }

        if (schema.validation) {
            let [valid, msg] = checkConditionWithMsg(
                formData,
                schema.validation
            );

            if (!valid) {
                nofifyWarning ( t ( "warning.formDataValidationFail", { msg: msg } ) );
                return;
            }
        }

        if(formData.wareHouseCode === formData.moveWarehouseCode) {
            nofifyWarning(t("warning.moveWarehouseCode"));
            return;
        }

        // build base api url
        let url = "/api/MomSysInspection/inspectionItemMove";
        let apiData = { ...formData };
        let form = new FormData ();
        let json = {};
        let deleted = {};

        //autoFormDialog columnMap 생성부분 
        if (schema) { 
            let columnMap = {};
            schema.columns.map(column => columnMap[column.name] = column);
            schema.columnMap = columnMap;
        }

        
        for(const formItem in apiData) {
            json[formItem] = apiData[formItem];
        }

        form.append ("deleted", JSON.stringify(deleted));
        form.append ("json", JSON.stringify(json));
        
        apiClient
            .post(url, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((result) => onApiSuccess(result))
            .catch((reason) => onApiFailure(reason));
    }

    function notFileKey(columnMap, key) {
        if (columnMap && columnMap[key] && columnMap[key].formItemType !== "file") {
           return key;
        }
    }

    function notUndefined(apiData, key) {
        if(apiData !== undefined) {
            return key;
        }
    }

    const onCancel = () => {
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
                companyCode: undefined,
                description: undefined,
                cost: undefined,
                mainCustomer: undefined,
                minPurchaseQty: undefined,
            }
            return newFormData;
        });
        instance.hide();
    };

    const checkKeepOpen = () => {
        return (
            <>
                <FormControlLabel
                    control={
                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={ ()=> setKeepOpen( ( keepOpen ) => ( !keepOpen ) ) }
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{flexGrow: 1}}></div>
            </>
        )
    }

    const setInitialDataCallback = (formData) => {
        let keys = Object.keys(initialData);
        for(const key of keys) {
            formData[key] = initialData[key];
        }
    }

    const onChange = (formData) => {
        setFormData (formData);
        setInteraction (true);
    }

    const onCloseNotification = () => {
        setNotification((notification) => {
            return ({...notification, open: false});
        });
    };

    const onCloseDialog = () => {
        setInteraction (false);
        setFormData ((formData) => {
            let newFormData = {
                ...formData,
                companyCode: undefined,
                description: undefined,
                cost: undefined,
                mainCustomer: undefined,
            }
            return newFormData;
        });
        setFailedLotList([]);
        
        if ( onClose ) {
            onClose ();
        }
    }

    
    const notifyWarning = (msg) => {
        console.warn (msg);
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onChangeFailedLotList = (failedLotList) => {
        setFailedLotList ( failedLotList );
    };

    const addFailedLot = (failedLotListSchema, formData) => {
        if(!checkItemValidation(failedLotListSchema, formData)) {
            console.error("Form Validation Failed");
            return;
        }

        if(formData.failureCode && formData.qty) {
            setFailedLotList((failedLotList) => {
                let lotList = cloneDeep(failedLotList);
                let lotInList = false;
                for(const lot of lotList) {
                    if(lot.failureCode === formData.failureCode) {
                        lot.qty += parseFloat(formData.qty);
                        lotInList = true;
                    }
                }

                if(!lotInList) {
                    lotList.push({ ...formData, qty: parseFloat(formData.qty) });
                }
                
                if(onChangeFailedLotList) {
                    onChangeFailedLotList(lotList);
                }
                return lotList;
            });
        }
    };

    useEffect(() => {
        let collectionView = new CollectionView(failedLotList);
        setCollectionView(collectionView);
    }, [failedLotList]);

    return (
        <Dialog
            id={id}
            moveable={moveable ? moveable : uiConf.dialogMoveable}
            resizable={resizable ? resizable : uiConf.dialogResizable}
            fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
            maxWidth="md"
            onClose={onCloseDialog}
            onInitialized={onDialogInitialized}
            {...others}
        >
            <DialogHeaderWithClose>
                <DialogTitle>
                    { t ( "dialog.title.inspectionItemMove" ) }
                </DialogTitle>
            </DialogHeaderWithClose>
        <Divider />

        <DialogContent>
            <AutoForm
                id="InspectionItemMoveDialog"
                schema={modifiedSchema}
                mode="edit"
                initialData={initialData}
                onChange={onChange}
            />
            <Snackbar
                open={notification.open && notification.severity !== "success"}
                autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                onClose={onCloseNotification}
            >
                <Alert
                    onClose={onCloseNotification}
                    variant="filled"
                    severity={notification.severity}
                >
                    {notification.msg}
                </Alert>
            </Snackbar>
        </DialogContent>
        <Divider />
        <DialogActionsOkCancel
            firstActionComponent={checkKeepOpen}
            labels={[ t("common.add")]}
            buttonDisabled={[!interaction, false]}
            onOk={() => onOk(schema, failedLotList, formData)}
            onCancel={onCancel}
        />
        </Dialog>
    );
}

export default InspectionItemMoveDialog;

